import { auth, type SchemaResponse, unAuth } from "@/modules/api"
import { EKocCategory } from "@/modules/helpers/enum"
import { UpdateProfile } from "@/modules/helpers/hooks"
import type { User } from "@/modules/types"

export const uploadAvatar = async (nameAvatar?: string) => {
  return await auth.post<
    SchemaResponse<{
      userId: string
      avatarUploadUrl: string
    }>
  >("user/presigned-url", {
    nameAvatar
  })
}

export const addReferralCode = (referralCode: string) => {
  return auth.post<SchemaResponse<null>>(`user/referral`, {
    referralBy: referralCode?.trim()
  })
}

export const authorizeShareGmv = async () => {
  return await auth.get<SchemaResponse<null>>("user/gmv-tiktok")
}

export const uploadBackground = async (nameBackground: string) => {
  return await auth.post<
    SchemaResponse<{
      userId: string
      backgroundUploadUrl: string
    }>
  >("user/presigned-url", {
    nameBackground
  })
}

export const uploadIdCard = async (nameIdCard: string) => {
  return await auth.post<
    SchemaResponse<{
      userId: string
      uploadUrl: string
    }>
  >("user/presigned-url", {
    nameIdCard
  })
}

export const getUserInfo = async () => {
  return auth.get<SchemaResponse<User>>("user")
}

export type UpdateUserName = {
  username: string
  lastName: string
  firstName: string
}

export const updateChannelOrientation = (channelOrientation: EKocCategory[]) => {
  return auth.patch<SchemaResponse<null>>(`user/info`, {
    channelOrientation
  })
}

export const getVerifyCodeByPhoneNumber = async (phone: string) => {
  return await auth.put<SchemaResponse<null>>("user/phone", { phone })
}
export const requestApplyAgencyCode = (code: string) => {
  return auth.post<SchemaResponse<null>>(`kol/agency?code=${code}`)
}

export const updateProfileSetup = async (data: {
  password: string
  firstName: string
  lastName: string
  username: string
  email: string
}) => {
  const token = localStorage.getItem("@opt_token")
  return unAuth.post<SchemaResponse<{ accessToken: string }>>(
    "user/create",
    {
      firstName: data.firstName,
      lastName: data.lastName,
      username: data.username,
      password: data.password,
      email: data.email,
      roleName: "KOL"
    },
    {
      params: {
        token
      }
    }
  )
}

export const requestDeleteUser = () => {
  return auth.put<SchemaResponse<null>>("user/delete")
}

export const updateUserProfile = async (data: UpdateProfile) => {
  return await auth.patch<SchemaResponse<null>>("user/profile", data)
}

export const updateUserInfo = async (data: Partial<User>) => {
  return await auth.patch<SchemaResponse<null>>("user/info", data)
}

export type SettingUser = { ads: boolean; news: boolean; remind: boolean; inbox: boolean }

export const addReferralBy = (referralBy: string) => {
  return auth.post<SchemaResponse<null>>(`user/referral`, { referralBy: referralBy?.trim() })
}
export type UpdateIdentifyCardProfile = {
  identifyNumber?: string
  placeGrantIdentify?: string
  placeOfOrigin?: string
  placeOfResidence?: string
  identifyNumberFrontImage?: string
  identifyNumberBackImage?: string
  fullName?: string
  dateGrantIdentify?: string
}
export const updateIdentifyCardProfile = async (data: UpdateIdentifyCardProfile) => {
  return await auth.patch<SchemaResponse<null>>("user/profile", data)
}

export type UpdateTaxCodePayload = {
  taxCode: string
}

export const updateTaxCode = async (data: UpdateTaxCodePayload) => {
  return await auth.patch<SchemaResponse<null>>("user/profile", data)
}
